import { useDispatch } from "react-redux";
import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import { ClientsService } from "../services/clients";
import {
  ContactProfile,
  ContactProfileToEdit,
} from "../types/clients-module-types";
import eventHandler from "../../SharedModule/utils/eventHandler";

export const useChangeStatusContact = (
  showModal: (options: any) => Promise<void>,
  closeModal: () => void,
  isReactivate: boolean,
  isRemove: boolean,
  clientId: number,
  profile: ContactProfile
) => {
  const dispatch = useDispatch();
  const totalsClientsAssigned = profile.clients.length;

  const changeStatus = async () => {
    let deactivateText: string;
    if (isRemove) {
      deactivateText =
        "Are you sure you want to remove this Contact from this Client? It will remain in all other Clients it is assigned to.";
    } else if (totalsClientsAssigned > 1) {
      deactivateText =
        "Are you sure you want to deactivate this Contact? It will be deactivated from all Clients is it assigned to.";
    } else {
      deactivateText = "Are you sure you want to deactivate this Contact?";
    }

    const options = isReactivate
      ? {
          title: "Reactivate Contact",
          text: "Are you sure you want to Reactivate this Contact?",
          btnLabel: "Reactivate",
        }
      : {
          title: isRemove ? "Remove Contact" : "Deactivate Contact",
          text: deactivateText,
          btnLabel: isRemove ? "Remove" : "Deactivate",
        };

    await showModal(options);
    closeModal();

    const {
      clients,
      contactRoleType,
      country,
      discProfile,
      lastUpdateBy,
      lastUpdateDate,
      salutation,
      state,
      ...rest
    } = profile;

    // isRemove => should remove clientId from clients list. Deactivate remove all ids.
    let responseIds: number[] = isRemove
      ? clients.map((client) => client.id).filter((n) => n !== clientId)
      : clients.map((client) => client.id);

    // isReactivate should set clientIds with clientId
    const cloned: ContactProfileToEdit = {
      ...rest,
      clientIds: responseIds,
      isActive: isRemove || isReactivate,
    };

    // Remove properties with null values
    const cleaned = Object.fromEntries(
      Object.entries(cloned).filter(([_, value]) => value !== null)
    );

    await ClientsService.updateContactProfile(cleaned, cloned.id)
      .then((response) => {
        dispatch(addToast({ mode: "success", message: response.message }));
      })
      .catch(() => {
        dispatch(
          addToast({
            mode: "error",
            message: "Something went wrong updating this contact",
          })
        );
      });
    eventHandler.dispatch("toast action", { isClosed: false });
  };

  return changeStatus;
};
